import classnames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { generateImageURL } from '../../../../utils/image';

import useStyles from './styles';
import IDemoImages from './types';

function DemoImages({ images, text, className, onImageClick }: IDemoImages) {
  const classes = useStyles();

  return (
    <div className={classnames(classes.demoArea, className)}>
      <div className={classes.uploaderSuggestion}>{text}</div>
      <div className={classes.imageList}>
        {images.map((image, index) => (
          <div className={classes.suggestedImgContainer} key={index}>
            <div className={classes.suggestedImgWrapper}>
              <LazyLoadImage
                src={generateImageURL(image.src)}
                alt={image.alt}
                className={classes.suggestedImg}
                onClick={() => onImageClick(image.srcLarge || image.src)}
                width={48}
                height={48}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default DemoImages;
